import SwiperCore, { Autoplay, EffectFade } from 'swiper/core';
SwiperCore.use([Autoplay, EffectFade]);
import Swiper from 'swiper';

(function($) {
  $(function() {
    $('.text-image-slider__slider').each(function() {
      var $slider = $(this);
      var $slides = $slider.find('.swiper-slide');

      if($slides.length < 2) {
        return;
      }

      var swiper = new Swiper($slider.get(0), {
        loop: true,
        effect: 'fade',
        disableOnInteraction: false,
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 5000,
        },
        speed: 700
      });
    });
  });
})(jQuery);
